export default {
  title: 'Puncte & Reduceri',
  store_credit: 'Credit magazin',
  points_balance: 'Sold puncte',
};
